/* ==========================================================================
   Maison du Bebè — Lista nascita (Swym Wishlist Plus in modalità "solo SDK")
   Cuori sulle card, bottone in scheda prodotto, contatore in header.
   La lista dell'utente si chiama "Lista nascita" (creata al primo cuore).
   Dati extra salvati su Swym:
     lista  → lnote = messaggio, lprops = { bimbo, data, genitori, consegna }
     articolo → qty = quantità desiderata, note = nota, cprops = { top: 1 } (ci tengo molto)
   API pubblica: window.BLLN (usata da bl-ln-page.js)
   ========================================================================== */
(function () {
  'use strict';
  if (window.BLLN) return;

  var CFG = window.BLLN_CFG || {};
  var LIST_NAME = CFG.listName || 'Lista nascita';
  var PAGE = CFG.page || '/pages/lista-nascita';

  var S = { swat: null, ready: false, lid: null, list: null, items: [], byEpi: {}, sdk: false };
  var waiting = [];
  var pending = {};

  /* ---------- utilità ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function handleFromUrl(u) { var m = String(u || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function abs(u) { try { return new URL(u, location.origin).href.split('?')[0]; } catch (e) { return u; } }
  var productCache = {};
  function fetchProduct(handle) {
    if (!handle) return Promise.reject('no handle');
    if (!productCache[handle]) {
      productCache[handle] = fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
        .catch(function (e) { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(html, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bl-ln-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 4200);
  }

  /* ---------- stato lista ---------- */
  function setList(list) {
    S.list = list || null;
    S.lid = list ? list.lid : null;
    S.items = (list && list.listcontents) || [];
    S.byEpi = {};
    S.items.forEach(function (it) { S.byEpi[String(it.epi)] = it; });
  }
  function pick(lists) {
    if (!lists || !lists.length) return null;
    for (var i = 0; i < lists.length; i++) if (lists[i].lname === LIST_NAME) return lists[i];
    return lists[0];
  }
  function changed() {
    paint(document);
    document.dispatchEvent(new CustomEvent('blln:change', { detail: S }));
  }
  function refresh(cb) {
    S.swat.fetchLists({
      callbackFn: function (lists) { setList(pick(lists)); done(); },
      errorFn: function (e) { console.warn('[lista nascita] fetchLists', e); done(e); }
    });
    function done(err) {
      var first = !S.ready;
      S.ready = true;
      changed();
      if (first) { var w = waiting; waiting = []; w.forEach(function (f) { try { f(S); } catch (e) { console.error(e); } }); }
      if (cb) cb(err);
    }
  }
  function ensureList(cb) {
    if (S.lid) return cb(null, S.lid);
    S.swat.createList({ lname: LIST_NAME }, function (list) {
      list.listcontents = list.listcontents || [];
      setList(list);
      cb(null, S.lid);
    }, function (err) {
      // il nome esiste già (altra scheda / altro dispositivo): ricarico
      refresh(function () { if (S.lid) cb(null, S.lid); else cb(err || 'createList'); });
    });
  }

  /* ---------- aggiungi / togli ---------- */
  // data: { epi, empi?, du?, handle?, dt?, iu?, pr? }
  function resolve(data) {
    if (data.empi && data.du) return Promise.resolve(data);
    var handle = data.handle || handleFromUrl(data.du);
    return fetchProduct(handle).then(function (p) {
      var v = null;
      for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(data.epi)) v = p.variants[i];
      v = v || p.variants[0];
      return {
        epi: Number(v.id), empi: Number(p.id), du: abs(p.url || ('/products/' + handle)),
        dt: data.dt || p.title, iu: data.iu || (v.featured_image && v.featured_image.src) || p.featured_image || '',
        pr: data.pr != null ? data.pr : v.price / 100
      };
    });
  }
  function add(data, opts) {
    opts = opts || {};
    return new Promise(function (ok, ko) {
      resolve(data).then(function (prod) {
        ensureList(function (err, lid) {
          if (err) return ko(err);
          var item = { epi: prod.epi, empi: prod.empi, du: prod.du, qty: opts.qty || 1 };
          if (prod.dt) item.dt = prod.dt;
          if (prod.iu) item.iu = String(prod.iu).replace(/^\/\//, 'https://');
          if (prod.pr != null) item.pr = Number(prod.pr);
          S.swat.addToList(lid, item, function (added) {
            var it = Object.assign({}, item, added || {});
            S.items.push(it);
            S.byEpi[String(it.epi)] = it;
            if (S.list) { S.list.listcontents = S.items; S.list.cnt = S.items.length; }
            changed();
            ok(it);
          }, ko);
        });
      }).catch(ko);
    });
  }
  function remove(epi) {
    var it = S.byEpi[String(epi)];
    if (!it || !S.lid) return Promise.resolve();
    return new Promise(function (ok, ko) {
      S.swat.deleteFromList(S.lid, { epi: it.epi, empi: it.empi, du: it.du }, function () {
        S.items = S.items.filter(function (x) { return String(x.epi) !== String(epi); });
        delete S.byEpi[String(epi)];
        if (S.list) { S.list.listcontents = S.items; S.list.cnt = S.items.length; }
        changed();
        ok();
      }, ko);
    });
  }
  function updateItem(epi, patch) {
    var it = S.byEpi[String(epi)];
    if (!it) return Promise.reject('not found');
    var body = { epi: it.epi, empi: it.empi, du: it.du, qty: it.qty || 1, note: it.note || '', cprops: Object.assign({}, it.cprops || {}) };
    if ('qty' in patch) body.qty = patch.qty;
    if ('note' in patch) body.note = patch.note;
    if (patch.cprops) Object.assign(body.cprops, patch.cprops);
    return new Promise(function (ok, ko) {
      S.swat.updateListItem(S.lid, body, function (res) {
        it.qty = body.qty; it.note = body.note; it.cprops = body.cprops;
        if (res && typeof res === 'object') { ['qty', 'note', 'cprops'].forEach(function (k) { if (res[k] != null) it[k] = res[k]; }); }
        changed();
        ok(it);
      }, ko);
    });
  }
  function updateInfo(info) {
    // info: { lnote, lprops }
    return new Promise(function (ok, ko) {
      ensureList(function (err, lid) {
        if (err) return ko(err);
        var cfg = { lid: lid };
        if ('lnote' in info) cfg.lnote = info.lnote;
        if (info.lprops) cfg.lprops = Object.assign({}, (S.list && S.list.lprops) || {}, info.lprops);
        S.swat.updateList(cfg, function (res) {
          if (S.list) { if ('lnote' in cfg) S.list.lnote = cfg.lnote; if (cfg.lprops) S.list.lprops = cfg.lprops; }
          changed();
          ok(res);
        }, ko);
      });
    });
  }
  function shareUrl() {
    return new Promise(function (ok, ko) {
      if (!S.swat.platform.isLoggedIn()) return ko('login');
      ensureList(function (err, lid) {
        if (err) return ko(err);
        S.swat.markListPublic(lid, function () {
          ok(location.origin + PAGE + '?lista=' + encodeURIComponent(lid));
        }, ko);
      });
    });
  }
  function fetchPublic(lid) {
    return new Promise(function (ok, ko) {
      S.swat.fetchListDetails({ lid: lid }, function (res) { ok((res && res.list) || res); }, ko);
    });
  }

  /* ---------- UI: cuori e contatore ---------- */
  function heartData(btn) {
    var d = btn.dataset;
    var epi = d.lnEpi;
    // in scheda prodotto: variante scelta nel modulo
    if (d.lnForm != null) {
      var scope = btn.closest('product-details, .product-details, .product-information, main') || document;
      var input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) epi = input.value;
    }
    return { epi: epi, empi: d.lnEmpi, du: d.lnDu, handle: d.lnHandle, dt: d.lnTitle, iu: d.lnImage, pr: d.lnPrice ? Number(d.lnPrice) / 100 : null };
  }
  function paint(root) {
    (root || document).querySelectorAll('[data-ln-heart]').forEach(function (btn) {
      var epi = heartData(btn).epi;
      var on = !!S.byEpi[String(epi)];
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = on ? 'Nella tua lista nascita' : 'Aggiungi alla lista nascita';
      btn.setAttribute('aria-label', lbl + (btn.dataset.lnTitle ? ': ' + btn.dataset.lnTitle : ''));
      btn.title = lbl;
      var txt = btn.querySelector('[data-ln-text]');
      if (txt) txt.textContent = on ? (btn.dataset.lnOnText || 'Nella tua lista nascita') : (btn.dataset.lnOffText || 'Aggiungi alla lista nascita');
      btn.classList.toggle('is-ready', S.ready);
    });
    var n = S.items.length;
    document.querySelectorAll('[data-ln-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-ln-link]').forEach(function (a) {
      a.setAttribute('aria-label', 'Lista nascita' + (n ? ' (' + n + (n === 1 ? ' articolo' : ' articoli') + ')' : ''));
    });
  }
  function onHeart(e) {
    var btn = e.target.closest('[data-ln-heart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (!S.swat) { toast('La lista nascita si sta caricando, riprova tra un attimo.', true); return; }
    var data = heartData(btn);
    var key = String(data.epi);
    if (pending[key]) return;
    pending[key] = true;
    btn.classList.add('is-busy');
    var wasOn = !!S.byEpi[key];
    var p = wasOn ? remove(data.epi) : add(data);
    p.then(function () {
      if (wasOn) toast('Tolto dalla lista nascita.');
      else {
        btn.classList.add('is-pop');
        setTimeout(function () { btn.classList.remove('is-pop'); }, 450);
        toast('Aggiunto alla lista nascita <a href="' + PAGE + '">Vedi la lista</a>');
      }
    }).catch(function (err) {
      console.warn('[lista nascita]', err);
      toast('Non è stato possibile aggiornare la lista. Riprova.', true);
    }).finally(function () {
      delete pending[key];
      btn.classList.remove('is-busy');
      paint(document);
    });
  }
  document.addEventListener('click', onHeart, true);

  // card create dopo il caricamento (ricerca, raccomandazioni, filtri)
  var mo = new MutationObserver(function (muts) {
    if (!S.ready) return;
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-ln-heart],[data-ln-count]') || n.querySelector('[data-ln-heart],[data-ln-count]'))) { paint(n.parentNode || document); }
      }
    }
  });
  function startObserver() { mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.body) startObserver(); else document.addEventListener('DOMContentLoaded', startObserver);

  // cambio variante in scheda prodotto
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-picker, [name="id"], .variant-picker')) setTimeout(function () { paint(document); }, 60);
  });

  /* ---------- avvio Swym ---------- */
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    S.swat = swat;
    S.sdk = true;
    refresh();
    if (swat.evtLayer) {
      swat.evtLayer.addEventListener('sw:customerInfoRefreshed', function () { refresh(); });
    }
  });

  window.BLLN = {
    state: S,
    page: PAGE,
    listName: LIST_NAME,
    ready: function (fn) { if (S.ready) fn(S); else waiting.push(fn); },
    isLoggedIn: function () { try { return !!(S.swat && S.swat.platform.isLoggedIn()); } catch (e) { return false; } },
    add: add, remove: remove, updateItem: updateItem, updateInfo: updateInfo,
    shareUrl: shareUrl, fetchPublic: fetchPublic, fetchProduct: fetchProduct,
    handleFromUrl: handleFromUrl, toast: toast, esc: esc, paint: paint
  };
})();
